module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/banner-282818988c80d47a5befb2458e79dfe9.svg";